// src/pages/Login.jsx
// Clean, professional login page
// No jargon — just email, password, entity selector

import { useState } from "react";
import { api } from "../services/api";

export default function Login({ onLogin }) {
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const data = await api.post("/auth/login", { email, password });
      localStorage.setItem("ts360_token", data.token);
      localStorage.setItem("ts360_user",  JSON.stringify(data.user));
      onLogin(data.user, data.token);
    } catch (err) {
      setError(err.message || "Invalid email or password");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "linear-gradient(135deg, #1B3F6E 0%, #0d2444 60%, #162d4f 100%)",
      fontFamily: "'Inter', system-ui, sans-serif",
    }}>
      <div style={{
        background: "#fff", borderRadius: 16, padding: "40px 44px",
        width: "100%", maxWidth: 400, boxShadow: "0 20px 60px rgba(0,0,0,.3)",
      }}>
        {/* Brand */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: "#1B3F6E", letterSpacing: ".01em" }}>TaxStuff360</div>
          <div style={{ fontSize: 13, color: "#2E86AB", marginTop: 4, fontWeight: 500 }}>Healthcare Accounting</div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 18 }}>
            <label style={labelStyle}>Email address</label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              required autoFocus placeholder="you@hospital.com"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={labelStyle}>Password</label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              required placeholder="••••••••"
              style={inputStyle}
            />
          </div>

          {error && (
            <div style={{ background: "#FFEBEE", border: "1px solid #FFCDD2", borderRadius: 8,
              padding: "10px 14px", color: "#B71C1C", fontSize: 13, marginBottom: 16 }}>
              {error}
            </div>
          )}

          <button
            type="submit" disabled={loading}
            style={{
              width: "100%", padding: "13px", background: loading ? "#90A4AE" : "#1B3F6E",
              color: "#fff", border: "none", borderRadius: 8, fontSize: 14,
              fontWeight: 600, cursor: loading ? "not-allowed" : "pointer", letterSpacing: ".02em",
            }}
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <div style={{ textAlign: "center", marginTop: 24, fontSize: 12, color: "#90A4AE" }}>
          Contact your administrator if you need access
        </div>
      </div>
    </div>
  );
}

const labelStyle = {
  display: "block", fontSize: 12, fontWeight: 600, color: "#455A64",
  textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 6,
};
const inputStyle = {
  width: "100%", padding: "11px 14px", border: "1.5px solid #CFD8DC",
  borderRadius: 8, fontSize: 14, color: "#1a1a1a", outline: "none",
  boxSizing: "border-box", transition: "border-color .15s",
  fontFamily: "inherit",
};
